<template>
  <!-- Vue conditional to check if there is any content in document -->
  <div v-if="hasContent" class="page">
    <div class="home">
      <!-- Button to edit document in dashboard -->
      <prismic-edit-button :documentId="documentId"/>
      <!--<div class="blog-avatar" :style="{ backgroundImage: 'url(' + fields.image + ')' }">
      </div> -->
      <!-- Template for page title -->
      <h1 class="blog-title">
        {{ $prismic.richTextAsPlain(fields.headline) }}
      </h1>
      <!-- Template for page description -->
      <p class="blog-description">{{ $prismic.richTextAsPlain(fields.description) }}</p>
    </div>
    <!-- Vue reference for blog posts component -->
    <blog-posts/>
  </div>
</template>

<script>
import BlogPosts from '../components/BlogPosts.vue'

export default {
  name: 'blog-home',
  components: {
    BlogPosts
  },
  data () {
    return {
      documentId: '',
      fields: {
        headline: null,
        description: null,
        image: null
      },
      posts: [],
      linkResolver: this.$prismic.linkResolver,
      hasContent: false
    }
  },
  methods: {
    getContent () {
      //Query to get home content
      this.$prismic.client.getSingle('blog_home')
        .then((document) => {
          if (document) {
            this.documentId = document.id
            this.fields.headline = document.data.headline;
            this.fields.description = document.data.description;
            this.fields.image = document.data.image.url;

            //Check that the blog home contains content
            this.checkForContent();

          } else {
            //returns error page
            this.$router.push({ name: 'not-found' })
          }
        })
    },
    //Function to check for any content on the blog home page
    checkForContent(){
      if (
        this.fields.image != undefined ||
        this.$prismic.richTextAsPlain(this.fields.headline) !== "" ||
        this.$prismic.richTextAsPlain(this.fields.description) !== ""
      ) {
        this.hasContent = true;
      }
    },
  },
  created () {
    this.getContent()
    window.prismic.setupEditButton();
  }
}
</script>

<style scoped>
.home {
  max-width: 700px;
  margin: auto;
  text-align: center;
}
.home .blog-avatar {
  height: 145px;
  width: 150px;
  border-radius: 35%;
  background-position: center;
  background-size: cover;
  margin: 1em auto;
  margin-bottom: 1.8em;
  -webkit-box-shadow: 0 24px 35px -17.875px rgba(255, 255, 255, 0.22);
  box-shadow: 0 24px 35px -17.875px rgba(255, 255, 255, 0.19);
  border: 2px solid #2d2d2d;
}
.home .blog-description {
  font-size: 18px;
  color: #bec1c0;
  margin-top: -5px;
  font-weight: 200;
  letter-spacing: -.16px;
  margin-bottom: 3rem;
  padding-bottom: 3rem;
  font-family: colfax-web-regular,sans-serif;
  
  text-transform: uppercase!important;
  opacity: .75!important;
  letter-spacing: 2.25px!important;
  font-size: 0.975rem!important;
  margin-top: -11px!important;
  margin-bottom: 5.25rem!important;
  padding-left: 10px!important;
  padding-right: 10px!important;
}
/* Media Queries */
@media (max-width: 767px) {
  .home {
    padding: 0 20px;
  }
}

.home h1 {
  text-align: center!important;
  font-size: 55px!important;
  margin-top: 1.375rem!important;
  letter-spacing: -2.1px!important;
  line-height: 0.7 !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-bottom: 9px;
}

@media (max-width: 424px) {
    .home h1, .home .blog-description {
        text-align: center !important;
    }
    
    .home h1 {
        font-size: 3.875rem !important;
        margin-bottom: 2rem !important;   
        line-height: .775 !important;
    }
}
</style>
